// extracted by css-extract-rspack-plugin
export default {"unread":"UnreadIndicator-module__unread__nPoUkKD"};